var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWizOrgHierarchy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.3333,
    height: 22.6286,
    viewBox: "0 0 23.3333 22.6286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.1667 21V17.5H10.5V5.83333H8.16667V9.33333H0V0H8.16667V3.5H15.1667V0H23.3333V9.33333H15.1667V5.83333H12.8333V15.1667H15.1667V11.6667H23.3333V21H15.1667V21M2.33333 2.33333V2.33333V7V7V2.33333V2.33333M17.5 14V14V18.6667V18.6667V14V14M17.5 2.33333V2.33333V7V7V2.33333V2.33333M17.5 7H21V2.33333H17.5V7V7M17.5 18.6667H21V14H17.5V18.6667V18.6667M2.33333 7H5.83333V2.33333H2.33333V7V7",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizOrgHierarchy);
export default __webpack_public_path__ + "static/media/wiz-org-hierarchy.e3d11ee3acbd3dd6c7269084b81018f2.svg";
export { ForwardRef as ReactComponent };